<template>
  <v-system-bar app color="deep-purple darken-1" dark height="40" v-if="actingDealerId && !inSwitchedSession" data-bar="acting-dealer">
    <v-icon>mdi-shield-account</v-icon>
    <span class="ml-2">
      Estás dentro de <strong>{{ dealerName }}</strong> como Manager ({{ ACTING_GRUPO_ID ? 'Super Admin' : 'Administrador de Grupo' }}). Tus acciones quedan registradas a tu nombre.
    </span>
    <v-spacer></v-spacer>
    <v-btn text small @click="exitDealer" :loading="loading">
      <v-icon left small>mdi-arrow-left</v-icon>
      Volver al panel de Grupo
    </v-btn>
  </v-system-bar>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'acting-dealer-bar',

  data: () => ({
    loading: false
  }),

  computed: {
    ...mapGetters(['ACTING_DEALER_ID', 'ACTING_GRUPO_ID', 'CURRENT_USER', 'IN_SWITCHED_SESSION']),

    // El super admin que entra a un dealer ya tiene su barra de "switch session"
    inSwitchedSession () {
      return this.IN_SWITCHED_SESSION
    },

    actingDealerId () {
      return this.ACTING_DEALER_ID
    },

    dealerName () {
      return this.CURRENT_USER && this.CURRENT_USER.dealer ? this.CURRENT_USER.dealer.name : 'el concesionario'
    }
  },

  methods: {
    async exitDealer () {
      this.loading = true
      try {
        await this.$store.dispatch('EXIT_DEALER')
        // Recarga completa para limpiar el estado del dealer
        window.location.href = '/grupo/concesionarios'
      } catch (error) {
        console.error('Error al volver al panel de Grupo:', error)
        this.$toast.error('No se pudo volver al panel de Grupo')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.v-system-bar {
  font-weight: 500;
}
</style>
